<template lang="pug">
  transition(name="enter")
    .m-search-cont(v-if='isModalSearchProjectsVisible')
      .modal-search
        .input-search
          vm-icon(icon="search-outline" color="#414452" size="2rem")
          typeahead(src="/projects" queryParam="project_name" @getData="redirectTo")
      .dark-bg(@click="closeModalSearch")
</template>

<script>
import Typeahead from '@/components/aditionals/Typeahead.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'modal-search-projects',
  components: {
    Typeahead
  },
  props: {},
  data: () => ({}),
  methods: {
    ...mapActions([
      'setModalSearchProjectsVisible',
      'setProjectData'
    ]),
    closeModalSearch () {
      this.setModalSearchProjectsVisible(false)
    },
    redirectTo (project) {
      this.setProjectData(project)
      this.$router.push(`/projects/${project.id}/general`)
    }
  },
  computed: {
    ...mapGetters([
      'isModalSearchProjectsVisible'
    ])
  }
}
</script>

<style lang="scss" scoped>
.m-search-cont {
  position: fixed;
  width: 100%;
  height: 100vh;
  z-index: 99999;
  display: flex;
  justify-content: center;
  user-select: none;
  .dark-bg {
    background: rgba($color: #000000, $alpha: 0.4);
    width: 100%;
    height: 100%;
    position: absolute;
  }
  .modal-search {
    z-index: 2;
    margin: 3% 0 0 0;
    overflow: scroll;
    width: fit-content;
    height: fit-content;
    -webkit-box-shadow: 0px 0px 31px 1px rgba(0,0,0,0.15);
    -moz-box-shadow: 0px 0px 31px 1px rgba(0,0,0,0.15);
    box-shadow: 0px 0px 31px 1px rgba(0,0,0,0.15);
    backdrop-filter: blur(15px);
    border-radius: 10px;
    padding: 15px 20px;
    width: 50%;
    background: rgba($color: #a5bcce, $alpha: 0.6);
    .input-search {
      background: rgba($color: #ffffff, $alpha: 0.6);
      border-radius: 10px;
      padding: 10px;
      display: flex;
      align-items: flex-start;
    }
  }
}

.enter-enter-to, .enter-leave /* .fade-leave-active below version 2.1.8 */ {
  opacity: 1;
  transform: translateY(0px);
}

.enter-enter, .enter-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(20px);
}

@media only screen and (min-width: 1930px) {
  .modal-search {
    height: 8vh;
  }
}
</style>
